import { isSurveysEnabled } from './isEnabled'

export default isSurveysEnabled
